export default {
  online_header: 'Works online?',
  pos_header: 'Works at POS?',
  enabled: 'Enabled',
  needs_activation: 'Needs activation',
  disabled_in_template: 'Disabled in template',
  online_unavailable: 'Unavailable — configure your ordering provider',
  pos_unavailable: 'Unavailable — configure POS',
  pos_not_supported: 'Not supported on your POS',
  pos_coming_soon: 'Coming soon',
  activate: 'Activate',
  activate_online_aria: 'Activate online ordering for promo codes',
  activate_pos_aria: 'Activate POS for promo codes',
}
